import { Card, CardBody, Col, Row } from "reactstrap";
import VariationActivities from "./VariationActivities";
import VariationCheckboxUpgrade from "./VariationCheckboxUpgrade";
import { VariationCheckboxTitle } from "../../../../../../constants";
import { VariationCheckBoxSubTitle } from "../../../../../../data/formsAndTable/forms/FormControls";
import CommonCardHeader from "../../../../../../coreComponents/CommonCardHeader";

const VariationCheckbox = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={VariationCheckboxTitle} span={VariationCheckBoxSubTitle} />
        <CardBody>
          <Row className="g-3">
            <VariationActivities />
            <VariationCheckboxUpgrade />
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};
export default VariationCheckbox;
